import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import RemoveIcon from "@mui/icons-material/Remove";
import ProjectIcon from '@mui/icons-material/Policy';
import AddIcon from "@mui/icons-material/Add";
import TableStyleTwo from "../../components/TableStyleTwo";
import AddProject from '../project/Add'

const Project = ({ rows, toggleVisibilityProject, isVisibleProject, _id, setUserAction }) => {

  const [openAdd, setOpenAdd] = useState(false)

  // open add model
  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);


  const navigate = useNavigate();

  const columns = [
    {
      field: "projectNumber",
      headerName: "Project Number",
      flex: 1,
      cellClassName: "name-column--cell",
      renderCell: (params) => {
        const handleFirstNameClick = () => {
          navigate(`/dashboard/project/view/${params.id}`)
        };

        return (
          <Box onClick={handleFirstNameClick}>
            {params.value}
          </Box>
        );
      }
    },
    {
      field: "projectType",
      headerName: "Project Type",
      flex: 1,
    },
    {
      field: "projectStartDate",
      headerName: "Project start date",
      flex: 1,
      valueFormatter: (params) => {
        const date = new Date(params.value);
        return date.toDateString();
      },
    },
    {
      field: "projectEndDate",
      headerName: "Project end date",
      flex: 1,
      valueFormatter: (params) => {
        const date = new Date(params.value);
        return date.toDateString();
      },
    },
    {
      field: "projectStatus",
      headerName: "Project status",
      flex: 1,
    }
  ];


  return (
    <div>

      {/* Add Claim */}
      <AddProject open={openAdd} handleClose={handleCloseAdd} _id={_id} setUserAction={setUserAction} />

      <Box style={{ cursor: "pointer" }} p={2}>
        <Grid container display="flex" alignItems="center">
          <Stack direction="row" alignItems="center" justifyContent={"space-between"} width={"100%"}>
            <Stack direction="row" spacing={1} alignItems={"center"}>
              <Button
                onClick={toggleVisibilityProject}
                color="secondary"
                variant="contained"
                sx={{ width: "28px", minWidth: "0px", padding: "0px", height: "25px" }}
              >
                {isVisibleProject ? <RemoveIcon /> : <AddIcon />}
              </Button>
              <ProjectIcon />
              <Typography variant="h5">Project</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent={"flex-end"} spacing={2}>
              {isVisibleProject && (
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={handleOpenAdd}
                >
                  Create Project
                </Button>
              )}
            </Stack>
          </Stack>
        </Grid>
      </Box>
      {
        isVisibleProject &&
        <TableStyleTwo>
          <Box width="100%" height="30vh">
            <DataGrid
              rows={rows}
              columns={columns}
              getRowId={row => row._id}
              columnHeaderHeight={40}
            />
          </Box>
        </TableStyleTwo>
      }
    </div>
  );
};

export default Project;
